import {Link} from 'react-router-dom';
import React from 'react';
import {UserContext} from '../../../utils/usercontext';
import {postApi, putApi} from '../../../utils/functions';

import moment from 'moment';
import momenttz from 'moment-timezone';
import { DateTime } from 'luxon';
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import TimePicker from "rc-time-picker";
import 'rc-time-picker/assets/index.css';
import BBCode from '../../components/bbcode/bbcode';
import Genres from '../genres/genres';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';

import './schedule.css';

class ScheduleAdd extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      show: this.props.show ? true : false,
			access: 0,
			channel: this.props.channel,

			djs: [],
			genres: {},
			defaultgenres: '',

			dj: -1,
			title: '',
			description: '',
			startdate: Date(),
			starttime: Date(),
			enddate: Date(),
			endtime: Date(),
			genre: '',
			genrelist: {},
			genreshow: false,
			genrepicker: [],
			recurring: false,
			fortnightly: false,
			syndicate: '',
			overlap:{},

			audioport: false,
			facebook_time: 0,

			syndicates: {},
			syndicate_show: false,

			err_title: '',
			err_start: '',
			err_end: '',
			err_else: '',

    };
		this.close = this.close.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.submitEvent = this.submitEvent.bind(this);

		this.setStartDate = this.setStartDate.bind(this);
		this.setStartTime = this.setStartTime.bind(this);
		this.setEndDate = this.setEndDate.bind(this);
		this.setEndTime = this.setEndTime.bind(this);

		this.selectGenre = this.selectGenre.bind(this);
		this.removeGenre = this.removeGenre.bind(this);
		this.syndicate = this.syndicate.bind(this);
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {

		const user = this.context;

		let params = new URLSearchParams();
		params.append('channel', this.state.channel);
		const x = await postApi('/api/v2/schedule/prepare', params);
		if( x.status === 200 ) {
			let _dj = -1;
			if( user.user?.admin?.part_admin_access )
				for( let dj in x.data.djs )
					if( x.data.djs[dj].id === user.user.user.id )
						_dj = dj;
			this.setState({access: 2, djs: x.data.djs, genres: x.data.genres, defaultgenres: x.data.defaultgenres, audioport: x.data.audioport, dj: _dj>=0?_dj:-1});
		} else if( x.status === 220 ) {
			this.setState({access: 1});
		} else {

		}

		let d = new Date();
		d.setUTCHours(20);
		d.setMinutes(0);
		d.setSeconds(0);
		this.setState({facebook_time: Math.floor(d.getTime()/1000)});


	}

	close() {
		this.setState({ show: false });
		this.props.close();
	}


	handleChange(event) {
		let item = event.target.value;
		if( event.target.name === "dj" ) this.setState({dj: parseInt(item)});
		if( event.target.name === "title" ) this.setState({title: item});
		if( event.target.name === "description" ) this.setState({description: item});
		if( event.target.name === "genre" ) this.setState({genre: item, genreshow: (item.length>=4?true:false)}, () => {
			if( item.length>=4 ) {

				var _new = {};
				for( let i in this.state.genres ) {
					for( let j in this.state.genres[i] ) {
						let search = new RegExp(`(${item.replace(' ','|')})`,"gi");
						if( this.state.genres[i][j].match(search) != null ) {
							if( !_new[i] ) _new[i] = [];
							_new[i].push(this.state.genres[i][j]);
						}
					}
				}
				this.setState({genrelist: _new});
			}
		});
		if( event.target.name === "recurring" ) {
			if( !event.target.checked ) {
				this.setState({recurring: event.target.checked, fortnightly: event.target.checked});
			} else {
				this.setState({recurring: event.target.checked});
			}
		}
		if( event.target.name === "fortnightly" ) this.setState({fortnightly: event.target.checked});
		if( event.target.name === "syndicateshow" ) {
			this.syndicate(event.target.checked);
		}
		if( event.target.name === "syndicate" ) if( item !== 'Please Select ...' ) this.setState({syndicate: item});
	}

	

	setStartDate(e) {
		this.setState({startdate: e._d || e['$d']});
	}
	setStartTime(e) {
		this.setState({starttime: e._d});
	}
	setEndDate(e) {
		this.setState({enddate: e._d || e['$d']});
	}
	setEndTime(e) {
		this.setState({endtime: e._d});
	}

	async submitEvent(e) {
		e.preventDefault();

		var params = new URLSearchParams();
		params.append('channel', this.state.channel);
		if( this.state.dj >= 0 ) params.append('dj', this.state.djs[this.state.dj].id);
		params.append('title', this.state.title);
		params.append('description', this.state.description);

		try{
			var c = new Date(this.state.startdate);
				c.setHours(this.state.starttime.getHours());
				c.setMinutes(this.state.starttime.getMinutes());
				c.setSeconds(0);
				params.append('start', Math.floor( c.getTime() / 1000 ));
			} catch(error) {
			this.setState({err_start: '** Check Entry Date and Time'});
			return;
		}

		try{
		var d = new Date(this.state.enddate);
			d.setHours(this.state.endtime.getHours());
			d.setMinutes(this.state.endtime.getMinutes());
			d.setSeconds(0);
			params.append('end', Math.floor( d.getTime() / 1000 ));
		} catch(error) {
			this.setState({err_end: '** Check Entry Date and Time'});
			return;
		}
		params.append('genres', this.state.genrepicker.join(','));
		params.append('recurring', (this.state.recurring === true || this.state.recurring === 1) ? 1: 0);
		params.append('fortnightly', (this.state.fortnightly === true || this.state.fortnightly === 1) ? 1: 0);
		params.append('syndicate', this.state.syndicate );

		if( d.getTime() < c.getTime() ) {
			this.setState({err_end: '** End time cannot be before start time'});
			return;
		}
		const x = await putApi('/api/v2/schedule/add', params);
		if( x.status === 200 ) {
			this.close();
		} else {
			if(x.status===213) {
				this.setState({err_else: `Error: Schedule entry overlaps another entry`});
				this.setState({overlap: x.data});
			} else {
				this.setState({err_else: `Error: ${x.data}`, overlap: {}});
			}
		}
	}

	DJDate() {
		let timezone_non = new Date().getTimezoneOffset()*-1;//.toLocaleString("en-US", { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone });
		let timezone_uk = momenttz(timezone_non).tz("Europe/London")._offset;
		//let starttime = this.state.starttime.getTime()


		let c = new Date(this.state.startdate);
		try{
				c.setHours(this.state.starttime.getHours());
				c.setMinutes(this.state.starttime.getMinutes());
				c.setSeconds(0);
		 } catch(error) {}
		let d = new Date(this.state.enddate);
		try{
				d.setHours(this.state.endtime.getHours());
				d.setMinutes(this.state.endtime.getMinutes());
				d.setSeconds(0);
		 } catch(error) {}
		return (
			<>
				{moment(this.state.starttime).format("HH:mm")} - {moment(this.state.endtime).format("HH:mm")}
				{timezone_non!==timezone_uk &&
					<>
						<br />
						<small>({moment((Math.floor(c/1000)+(timezone_uk-timezone_non)*60)*1000).format("HH:mm")} - {moment((Math.floor(d/1000)+(timezone_uk-timezone_non)*60)*1000).format("HH:mm")} UK)</small>
					</>
				}
			</>
		)
	}

	DJTime() {
		try{ 
			const user = this.context;

			var str = "";
			if( user.user.admin.part_admin_access ) {
				if( this.state.title !== '' ) {
					str = this.state.title;
				} else {
					str = this.state.djs[this.state.dj].title?this.state.djs[this.state.dj].title:this.state.djs[this.state.dj].username;
				}
			} else {
				str = this.state.title?this.state.title:user.user.user.title?user.user.user.title:user.user.user.username;
			}
			if( this.state.description ) str += " - " + this.state.description;
			
			return str; //"DJ Jim Bob ~ 18:00 - 20:00";
		} catch(error) {
			return "";
		}
	}

	selectGenre(genre) {
		let pick = this.state.genrepicker;
		for( let i in pick ) if( genre === pick[i] ) return;
		pick.push(genre);
		this.setState({genre: '', genreshow: false, genrepicker: pick});
	}

	removeGenre(genre) {
		let pick = this.state.genrepicker;
		for( let i in pick ) if( genre === pick[i] ) pick.splice( i, 1 );
		this.setState({genrepicker: pick});
	}

	async syndicate(enabled) {
		let syndicate = this.state.syndicate;
		if( !enabled ) syndicate = '';
		this.setState({syndicate_show: enabled, syndicate},async ()=>{
			let params = new URLSearchParams();
			const x = await postApi('/api/v2/schedule/syndicate', params);
			this.setState({syndicates: x.data});
		});
	}

	render() {
		const user = this.context;
		let timezone_non = new Date().getTimezoneOffset()*-1;
		let timezone_uk = momenttz(timezone_non).tz("Europe/London")._offset;

		let rank = 0;
		let show = false;

		const djs = 
      this.state.djs.map((e,i) => {
				if( this.state.djs[i].id_level_new !== rank ) {
					show = true;
					rank = this.state.djs[i].id_level_new;
				} else {
					show = false;
				}
        return (
					<React.Fragment key={i}>
						{show &&
							<option disabled={true}>
								{rank===32&&<>Owner</>}
								{rank===31&&<>Admin</>}
								{rank===30&&<>Junior Admin</>}
								{rank===21&&<>Clubbers Djs</>}
								{rank===20&&<>Radio Djs</>}
							</option>
						}
						<option key={i} value={i}>
							{this.state.djs[i].title?
								<>&nbsp;&nbsp;&nbsp;&nbsp;{this.state.djs[i].title} ({this.state.djs[i].username})</>
							:
								<>&nbsp;&nbsp;&nbsp;&nbsp;{this.state.djs[i].username}</>
							}
						</option>
					</React.Fragment>
        )
      })
		const syndicates =
			Object.keys(this.state.syndicates).map((e,i) => {
				return (
					<option key={e} value={this.state.syndicates[e].filename}>
						{this.state.syndicates[e].filename} {this.state.syndicates[e].schedule&&<>&nbsp;&nbsp;&nbsp;&nbsp;{this.state.syndicates[e].schedule}</>}
					</option>
				)
			})
		const genrelist = 
			Object.keys(this.state.genrelist).map((e,i) => {
				return (
					<React.Fragment key={i}>
						<div>{e}</div>
						<div className="genrelist-left">
						{(() => {
							return Object.keys(this.state.genrelist[e]).map((f,j) => {
								return (
									<div key={j} className="genrelist" onClick={() => this.selectGenre(this.state.genrelist[e][f])}>{this.state.genrelist[e][f]}</div>
								)
							})
						})()}
					</div>
					<div className="genrelist-clear"></div>
				</React.Fragment>
			)})
		const genrepick = 
			Object.keys(this.state.genrepicker).map((e,i) => {
				return (
					<React.Fragment key={i}>
						<div className="genrepick" onClick={() => this.removeGenre(this.state.genrepicker[e])}>{this.state.genrepicker[e]}&nbsp;<i className="fa fa-times"></i></div>
					</React.Fragment>
				)})
		return (
			<>
				{this.state.access >0 &&
					<Modal show={this.state.show} onHide={this.close} backdrop="static" keyboard={false} size="xl" centered>
						<Modal.Header closeButton className="bg-dark">
							<Modal.Title>Create Mix365 {this.state.channel[0].toUpperCase() + this.state.channel.substring(1)} Schedule Entry</Modal.Title>
						</Modal.Header>
						<Modal.Body className="bg-dark">
							{this.state.access===2?
								<Row>
									<Col xs={12}>
										<Form onSubmit={this.submitEvent}>
										
											{user.user.user.rank>=5 &&
												<div className="form-group row pt-1 pb-0 mb-1">
													<label htmlFor="dj" className="col-sm-4 col-form-label col-form-label-sm ps-4">
														<strong>DJ</strong><br />
													</label>
													<div className="col-md-6 mt-2">
														<Form.Control as="select" name="dj" id="dj" onChange={this.handleChange} defaultValue={this.state.dj}>
															{djs}
														</Form.Control>
													</div>
												</div>
											}

											<div className="form-group row pt-1 pb-0 mb-1">
												<label htmlFor="title" className="col-sm-4 col-form-label col-form-label-sm ps-4">
													<strong>DJ Name</strong><br />
													<small>(Optional, leave blank to use DJ name)</small>
												</label>
												<div className="col-md-6 mt-2">
													<Form.Control type="text" name="title" id="title" onChange={this.handleChange} className="form-control-sm" placeholder="Title" />
												</div>
											</div>

											<div className="form-group row pt-1 pb-0 mb-1">
												<label htmlFor="description" className="col-sm-4 col-form-label col-form-label-sm ps-4">
													<strong>Description</strong><br />
													<small>(Optional)</small>
												</label>
												<div className="col-md-6 mt-2">
													<Form.Control type="text" name="description" id="description" onChange={this.handleChange} className="form-control-sm" placeholder="Description" />
												</div>
											</div>

											<div className="form-group row pt-1 pb-0 mb-1">
												<label htmlFor="description" className="col-sm-4 col-form-label col-form-label-sm ps-4">
													<strong>Start Datetime</strong><br />
													{/*<small>Timezone {DateTime.local().toFormat('ZZZZ')}</small><br />*/}
													<strong className="schedule_error">{this.state.err_start}</strong>
												</label>
												<div className="col-md-2 mt-2">
													<DatePicker onChange={(e)=>this.setStartDate(e)} getPopupContainer={(triggerNode)=>{return triggerNode.parentNode;}} onFocus={e => e.target.blur()} />
												</div>
												<div className="col-md-2 mt-2">
													<TimePicker
														placeholder="Select Time"
														use12Hours={false}
														showSecond={false}
														focusOnOpen={true}
														minuteStep={15}
														format="HH:mm"
														onChange={(e) => this.setStartTime(e)}
														popupClassName="text-oppisite"
														onFocus={e => e.target.blur()}
													/>
												</div>
											</div>

											<div className="form-group row pt-1 pb-0 mb-1">
												<label htmlFor="description" className="col-sm-4 col-form-label col-form-label-sm ps-4">
													<strong>End Datetime</strong><br />
													{/*<small>Timezone {DateTime.local().toFormat('ZZZZ')}</small><br />*/}
													<strong className="schedule_error">{this.state.err_end}</strong>
												</label>
												<div className="col-md-2 mt-2">
													<DatePicker onChange={this.setEndDate} getPopupContainer={(triggerNode)=>{return triggerNode.parentNode;}} onFocus={e => e.target.blur()} />
												</div>
												<div className="col-md-2 mt-2">
													<TimePicker
														placeholder="Select Time"
														use12Hours={false}
														showSecond={false}
														focusOnOpen={true}
														minuteStep={15}
														format="HH:mm"
														onChange={(e) => this.setEndTime(e)}
														popupClassName="text-oppisite"
														onFocus={e => e.target.blur()}
													/>
												</div>
											</div>

											<div className="form-group row pt-1 pb-0 mb-1">
												<label htmlFor="genres" className="col-sm-4 col-form-label col-form-label-sm ps-4">
													<strong>Genre</strong><br />
												</label>
												<div className="col-md-6 mt-2 genres">
													
													<Form.Control type="text" name="genre" id="genre" value={this.state.genre} onChange={this.handleChange} className="form-control-sm" placeholder="Search Genres">
														
													</Form.Control>
													{this.state.genreshow &&
														<div className="genreshow">
															<div className="genreshow-inner">
																{genrelist}
															</div>
														</div>
													}
													
													{user.user.admin.mod_access && !user.user.admin.part_admin_access && this.state.defaultgenres.length>0 &&
														<small>
															Leave blank for genres: {this.state.defaultgenres.replaceAll(',',', ')}<br />
														</small>
													}

													{user.user.admin.part_admin_access && this.state.djs[this.state.dj] && this.state.djs[this.state.dj].defaultgenres.length > 0 && 
														<small>
															Leave blank for genres: {this.state.djs[this.state.dj].defaultgenres.replaceAll(',',', ')}<br />
														</small>
													}
													<div className="col-md-6 mt-2">
														<div className="genrepick-box">
															{genrepick}
														</div>
													</div>
												</div>
											</div>

											<div className="form-group row pt-1 pb-0 mb-1">
												<label htmlFor="recurring" className="col-sm-4 col-form-label col-form-label-sm ps-4">
													<strong>Recurring</strong><br />
													<small>(Repeat event on weekly basis)</small>
												</label>
												<div className="col-md-6 mt-2">
													{/*<Form.Control type="checkbox" name="recurring" id="recurring" onChange={this.handleChange} className="form-control-sm"/>*/}
													<Form.Check type={"checkbox"} name="recurring" id="recurring" onChange={this.handleChange} />
												</div>
											</div>

											{user.user.admin.part_admin_access &&
												<div className="form-group row pt-1 pb-0 mb-1">
													<label htmlFor="fortnightly" className="col-sm-4 col-form-label col-form-label-sm ps-4">
														<strong>Fortnight</strong><br />
														<small>(Repeat event on fortnightly basis)</small>
													</label>
													<div className="col-md-6 mt-2">
														{/*<Form.Control type="checkbox" name="recurring" id="recurring" onChange={this.handleChange} className="form-control-sm"/>*/}
														<Form.Check type={"checkbox"} name="fortnightly" id="fortnightly" checked={this.state.fortnightly} onChange={this.handleChange} disabled={!this.state.recurring} />
													</div>
												</div>
											}

											{user.user.admin.part_admin_access &&
												<>
													<div className="form-group row pt-1 pb-0 mb-1">
														<label htmlFor="syndicate" className="col-sm-4 col-form-label col-form-label-sm ps-4">
															<strong>Syndicate</strong><br />
															
														</label>
														<div className="col-md-6 mt-2">
															{/*<Form.Control type="checkbox" name="recurring" id="recurring" onChange={this.handleChange} className="form-control-sm"/>*/}
															<Form.Check type={"checkbox"} name="syndicateshow" id="syndicateshow" checked={this.state.syndicateshow} onChange={this.handleChange} />
														</div>
													</div>
													<>
													{this.state.syndicate_show &&
														<>
															<div className="form-group row pt-1 pb-0 mb-1">
																<label htmlFor="syndicateshow" className="col-sm-4 col-form-label col-form-label-sm ps-4">
																	<strong>Show</strong><br />
																</label>
																<div className="col-md-6 mt-2">
																	<Form.Control as="select" name="syndicate" id="syndicate" onChange={this.handleChange} value={this.state.syndicate}>
																		<option>Please Select ...</option>
																		{syndicates}
																	</Form.Control>
																</div>
															</div>
														</>
													}
													</>
												</>
											}
											
											<Row className="pt-2 mb-1">
												<Col xs={12} className="ps-4" style={{borderBottom: 'var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color)'}}>
													<strong style={{color: 'var(--main-primary-color)'}}>Information</strong>
												</Col>
											</Row>
											{this.state.channel==='clubbers'&&
												<>
													<Row className="pt-2">
														<div className="col-sm-4 col-form-label col-form-label-sm ps-4">
															<strong>Overlay Template</strong>
														</div>
														<Col md={6}>
															Required
														</Col>
													</Row>
													<Row className="pt-2">
														<div className="col-sm-4 col-form-label col-form-label-sm ps-4">
															<strong>Genres</strong>
														</div>
														<Col md={6}>
															1 to 5 Required
														</Col>
													</Row>
												</>
											}
											{this.state.audioport &&
												<>
													<Row className="">
														<div className="col-sm-4 col-form-label col-form-label-sm ps-4">
															<strong>Icaset Port</strong>
														</div>
														<Col md={6}>
															{this.state.channel==='clubbers'?8010:8025}
														</Col>
													</Row>
												</>
											}

											<div className="form-group row pb-0 mb-1">
												<label className="col-sm-4 col-form-label col-form-label-sm ps-4">
													<strong>Facebook</strong>
												</label>
												<Col md={6}>
													To have your show posted on facebook for the following day, please ensure you have updated the schedule before <BBCode text={`[color=#FFFF00]${moment(this.state.facebook_time*1000).format("HH:mm")} ${DateTime.local().toFormat('ZZZZ')}[/color]`} /> hours
												</Col>
											</div>

											<div className="form-group row pt-1 pb-0 mb-1">
												<label className="col-sm-4 col-form-label col-form-label-sm ps-4"></label>
												<div className="col mt-2">
													<strong className="schedule_error">{this.state.err_else}</strong>
												</div>
											</div>

											{Object.values(this.state.overlap).length > 0 &&
												<div className="form-group row pt-1 pb-0 mb-1">
													<label className="col-sm-4 col-form-label col-form-label-sm ps-4"></label>
													<div className="col mt-2">
														<div className="p-schedule-event">
															<Row>
																<div className="text-vcenter" style={{width:180}}>
																	<div>
																		{moment(this.state.overlap.start*1000).format("HH:mm")} - {moment(this.state.overlap.end*1000).format("HH:mm")}
																		{/*timezone_non!==timezone_uk &&
																			<>
																				<br />
																				<small>({moment((this.state.overlap.start+(timezone_uk-timezone_non)*60)*1000).format("HH:mm")} - {moment((this.state.overlap.end+(timezone_uk-timezone_non)*60)*1000).format("HH:mm")} UK)</small>
																			</>
																		*/}
																	</div>
																</div>
																<div className="p-schedule-event-image">
																	<img src={`https://mix365.co.uk${this.state.overlap.avatar}`} width="84" height="84" alt="profile avatar" />
																</div>
																<Col className="p-schedule-event-right text-vertical">
																	<div>
																		<Link to={'#'} className="pb-4">
																			<FontAwesomeIcon icon="user" /> {this.state.overlap.username}
																		</Link>
																		{this.state.overlap.description && <><br /><FontAwesomeIcon icon="list" /> {this.state.overlap.description}</>}
																		<Genres genres={this.state.overlap.genres.length>0?this.state.overlap.genres:this.state.overlap.defaultgenres} />
																	</div>
																</Col>
															</Row>
														</div>
													</div>
												</div>
											}

										</Form>
									</Col>
									<Col xs={12}>
										<div className="p-schedule-event">
											{Object.keys(this.state.djs).length > 0 ?
												<>
													{this.state.dj>=0&&
														<Row>
															<Col xs={12} md={2} className="p-schedule-event-header text-vcenter">
																<div>
																	{this.DJDate()}
																</div>
															</Col>
															<div className="p-schedule-event-image">
																<img src={`https://mix365.co.uk/${this.state.djs[this.state.dj].avatar}`} width="84" height="84" alt="profile avatar" />
															</div>
															<Col className="p-schedule-event-right text-vertical">
																<div>
																	<Link to={'#'} className="pb-4">
																		<FontAwesomeIcon icon="user" /> {this.state.djs[this.state.dj].title?this.state.djs[this.state.dj].title:this.state.djs[this.state.dj].username}
																	</Link>
																	{this.state.description && <><br /><FontAwesomeIcon icon="list" /> <span className="p-schedule-description">{this.state.description}</span></>}
																	<Genres genres={this.state.genrepicker.length>0?this.state.genrepicker:this.state.djs[this.state.dj].defaultgenres} />
																</div>
															</Col>
														</Row>
													}
												</>
											:
												<Row>
													<div className="text-vcenter" style={{width:180}}>
														<div>
															{this.DJDate()}
														</div>
													</div>
													<div className="p-schedule-event-image">
														<img src={`https://mix365.co.uk/${user.user.user.avatar}`} width="84" height="84" alt="profile avatar" />
													</div>
													<Col className="p-schedule-event-right text-vertical">
														<div>
															<Link to={'#'} className="pb-4">
																<FontAwesomeIcon icon="user" /> {this.state.title?this.state.title:user.user.user.title?user.user.user.title:user.user.user.username}
															</Link>
															{this.state.description && <><br /><FontAwesomeIcon icon="list" /> <span className="p-schedule-description">{this.state.description}</span></>}
															<Genres genres={this.state.genrepicker.length>0?this.state.genrepicker:this.state.defaultgenres} />
														</div>
													</Col>
												</Row>
											}
										</div>
									</Col>
								</Row>
							:
								<>Oops, you don't have access to create schedule entry here</>
							}
						</Modal.Body>
						<Modal.Footer className="bg-dark">
							{this.state.access&&
								<Button size="sm" variant="primary" onClick={this.submitEvent}>Add Event</Button>
							}
							<Button size="sm" variant="secondary" onClick={this.close}>
								Close
							</Button>
						</Modal.Footer>
					</Modal>
					}
			</>
		);
	}
}

export default ScheduleAdd;